export const backdropStyles = {
  // Modern subtle backdrop (recommended)
  modern: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // Very subtle (for non-critical dialogs)
  subtle: {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // Strong (for important confirmations)
  strong: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // Alternative: Colored backdrop (trendy)
  colored: {
    backgroundColor: "rgba(17, 24, 39, 0.4)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // Classic: Opaque backdrop (traditional)
  opaque: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // Frosted glass effect (modern but can be distracting)
  frosted: {
    backgroundColor: "rgba(0, 0, 0, 0.15)",
    backdropFilter: "blur(8px)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // High contrast (for accessibility)
  highContrast: {
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },

  // Transparent (for minimal distraction)
  transparent: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    backdropFilter: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
  },
};

export const centerStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "94%", sm: "90%", md: "65%", lg: "50%" },
  height: { xs: "95%", sm: "auto", md: "auto", lg: "auto", xl: "auto" },
  minHeight: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  zIndex: 1300,
  border: "none",
  outline: "none",
  px: 2,
};

export const centerWideStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "96%", sm: "92%", md: "82%", lg: "74%", xl: "66%" },
  height: { xs: "95%", sm: "auto", md: "auto", lg: "auto", xl: "auto" },
  minHeight: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  zIndex: 1300,
  border: "none",
  outline: "none",
  px: 2,
};

export const sidePanelStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100vh",
  width: { xs: "100vw", sm: "500px", md: "580px" },
  bgcolor: "background.paper",
  borderLeft: "1px solid",
  borderColor: "divider",
  boxShadow: "-10px 0 25px -5px rgba(0, 0, 0, 0.1)",
  zIndex: 1300,
  outline: "none",
  overflow: "hidden",
  borderRadius: "0px!important",
};

export const toastStyle = {
  position: "fixed",
  bottom: "24px",
  right: "24px",
  width: { xs: "calc(100vw - 48px)", sm: "400px" },
  maxWidth: "400px",
  bgcolor: "background.paper",
  borderRadius: "12px!important",
  border: "1px solid",
  borderColor: "divider",
  boxShadow:
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  zIndex: 1300,
  outline: "none",
  overflow: "hidden",
};

export const dialogStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "380px", md: "420px" },
  maxWidth: "95vw",
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  zIndex: 1300,
  outline: "none",
  overflow: "hidden",
};

export const draggableModalStyle = {
  position: "relative",
  width: { xs: "95%", sm: "90%", md: "65%", lg: "50%" },
  height: { xs: "95%", sm: "auto", md: "auto", lg: "auto", xl: "auto" },
  minHeight: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  zIndex: 1300,
  border: "none",
  outline: "none",
};
